import { navigate } from "gatsby";
import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Table,
  Divider,
  Button,
  Form,
  Segment,
  Input,
} from "semantic-ui-react";
import { setOrderStatus } from "../../actions/support";

const getRole = order => {
  const roles = [];
  const { isBeneficialOwner, isRepresentative } = order.childrenSummary;
  if (isRepresentative) roles.push("representative");
  if (isBeneficialOwner) roles.push("beneficial owner");

  return roles.join(" / ");
};

const CompanyPanel = ({ order, setOrderStatus }) => {
  const [rejectionReason, setRejectionReason] = useState("");

  const handleAccept = () => setOrderStatus(order.code, "accepted");
  const handleReject = () =>
    setOrderStatus(order.code, "rejected", rejectionReason);
  const handleChange = (e, { value }) => setRejectionReason(value);

  const canBeAccepted = () =>
    order.identityVerificationStatus === "manual_verification_required" ||
    order.childrenOrders?.every(({ status }) => status === "accepted");

  return (
    <>
      {order.childrenOrders && (
        <>
          <Grid.Row>
            <Divider horizontal>Personal Orders</Divider>
          </Grid.Row>
          <Grid.Row>
            <Table compact celled selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>CODE</Table.HeaderCell>
                  <Table.HeaderCell>STATUS</Table.HeaderCell>
                  <Table.HeaderCell>NAME</Table.HeaderCell>
                  <Table.HeaderCell>ROLE</Table.HeaderCell>
                  <Table.HeaderCell>UPDATED AT</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {order.childrenOrders.map(o => (
                  <Table.Row
                    key={o.code}
                    positive={o.status === "accepted"}
                    negative={o.status === "rejected"}
                    onClick={() =>
                      navigate(`/dashboard/verification/${o.code}`)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <Table.Cell>{o.code}</Table.Cell>
                    <Table.Cell>
                      {o.status.replaceAll("_", " ").toUpperCase()}
                    </Table.Cell>
                    <Table.Cell>{`${o.formAnswers.firstName.answer} ${o.formAnswers.lastName.answer}`}</Table.Cell>
                    <Table.Cell>{getRole(o)}</Table.Cell>
                    <Table.Cell>{o.updatedAt}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Grid.Row>
        </>
      )}
      <Grid.Row>
        <Segment
          basic
          className="flexbox-spaced-between"
          style={{ padding: "1rem 0", width: "100%" }}
          padded
        >
          <Form onSubmit={handleReject}>
            <Input
              required
              type="text"
              placeholder="Rejection reason"
              style={{ width: "320px" }}
              value={rejectionReason}
              onChange={handleChange}
            />
            <Button
              type="submit"
              color="red"
              style={{ margin: "0 1rem" }}
              disabled={!rejectionReason}
            >
              REJECT
            </Button>
          </Form>
          <Button positive onClick={handleAccept} disabled={!canBeAccepted()}>
            ACCEPT
          </Button>
        </Segment>
      </Grid.Row>
    </>
  );
};

const mapDispatchToProps = { setOrderStatus };

export default connect(null, mapDispatchToProps)(CompanyPanel);
